import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import EntityTeeTimeRequestEngagement from "../../../assets/components/reports/EntityTeeTimeRequestEngagement";
import Report from "../../../models/Report";

class EntityCompletedTeeTimeBookingEngagementReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Entity Completed Tee-Time Booking Engagement</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <EntityTeeTimeRequestEngagement
                            description="The percentage of each entity's current members who have ever made a completed tee-time booking."
                            fetchReport={
                                Report.entityCompletedTeeTimeBookingEngagement
                            }
                            membersColumn='Members with completed bookings'
                            percentageColumn='% with completed bookings'
                            sortLabel='Completed booking %'
                            title='Entity completed tee-time booking engagement'
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default EntityCompletedTeeTimeBookingEngagementReport;
